import React from "react";
import styled from "styled-components";
import moment from "moment";
import { SCHEDULER_ROUNDING } from "@sonder/ui/source/styled/components/ScheduleLayer/constants";
import { roundToInterval } from "@sonder/ui/source/styled/components/ScheduleLayer/helpers";
import {
  RenderTriggerProps,
  TimePicker,
} from "@sonder/ui/source/styled/components/TimePicker";
import { Input } from "@sonder/ui/source/styled/fragments/Input";

const Container = styled.div`
  display: flex;

  > * {
    margin-right: 1rem;
  }
`;

interface TimeRangePickerProps {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
  onChangeStartDate: (date?: moment.Moment) => void;
  onChangeEndDate: (date?: moment.Moment) => void;
}

interface MilitaryTimePickerTriggerProps extends RenderTriggerProps {
  placeholder: string;
}

export const MilitaryTimePickerTrigger = ({
  date,
  placeholder = "To:",
  disabled,
  ...rest
}: MilitaryTimePickerTriggerProps) => (
  <Input
    disabled={disabled}
    {...rest}
    placeholder={placeholder}
    value={date ? date?.format("HH:mm") : ""}
    onBlur={(event: React.FocusEvent<HTMLInputElement>) =>
      roundToInterval(SCHEDULER_ROUNDING, moment(event.target.value, "HH:mm"))
    }
  />
);

export const TimeRangePicker = ({
  startDate,
  endDate,
  onChangeStartDate,
  onChangeEndDate,
}: TimeRangePickerProps) => {
  return (
    <Container>
      <TimePicker
        date={startDate}
        renderTrigger={props => (
          <MilitaryTimePickerTrigger {...props} placeholder="From:" />
        )}
        onChange={(nextDate: moment.Moment | undefined) => {
          if (nextDate) onChangeStartDate(nextDate);
        }}
      />
      <TimePicker
        date={endDate}
        renderTrigger={props => (
          <MilitaryTimePickerTrigger
            {...props}
            disabled={!startDate}
            placeholder="To:"
          />
        )}
        onChange={(nextDate: moment.Moment | undefined) => {
          if (nextDate) onChangeEndDate(nextDate);
        }}
      />
    </Container>
  );
};
